import { render } from "./OptionsList.vue?vue&type=template&id=2cbdd9c2&scoped=true&ts=true&lang=pug"
import script from "./OptionsList.vue?vue&type=script&lang=ts"
export * from "./OptionsList.vue?vue&type=script&lang=ts"

import "./OptionsList.vue?vue&type=style&index=0&id=2cbdd9c2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbdd9c2"]])

export default __exports__